// extracted by mini-css-extract-plugin
export default {"modal":"Eba","heading":"Fba","product":"Gba","note":"Hba","notetitle":"Iba","notetext":"Jba","line":"Kba","plan":"Lba","planimage":"Mba","description":"Nba"};
    if(module.hot) {
      // 1714654900404
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  